export default __webpack_public_path__ + "static/media/3ef0e69f3c889c1307330c36a501eb12.a91360f3.gif";